module.exports = __webpack_public_path__ + "img/Transportieren.18c1f852.svg";